<template>
   <div class="helpHeight">
      <router-view></router-view>
   </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.helpHeight{
  height: 100%;
}
</style>
